import Vue from "vue";
import Router from "vue-router";
import store from "@/store";

const _root = "_bayer";

Vue.use(Router);

const router = new Router({
  mode: "history",
  scrollBehavior: () => {
    return { x: 0, y: 0 };
  },
  routes: [
    {
      path: "/",
      // 사이드, 탑바 없이 풀 페이지
      component: () => import("@/layouts/full/LayoutFull.vue"),
      children: [
        {
          path: '/',
          redirect: "/home"
        },
        {
          path: "login",
          component: () => import(`@/${_root}/login/LoginPage`),
          beforeEnter: (to, from, next) => {
            // 로그인 상태가 아니면 로그인 페이지로 이동 처리
            if (store.getters.isAuthorized) {
              next("/home");
              return;
            }
            next();
          }
        },
        {
          path: "signup",
          component: () => import(`@/${_root}/signUp/SignUpPage`),
          beforeEnter: (to, from, next) => {
            // 로그인 상태가 아니면 로그인 페이지로 이동 처리
            // if (store.getters.isAuthorized) {
            //   next("/home");
            //   return;
            // }
            next();
          }
        },
        // {
        //   path: "/home",
        //   component: () => import(`@/${_root}/home/HomePage.vue`),
        // },
        {
          path: "find_pw",
          component: () => import(`@/${_root}/login/FindIDPasswordPage.vue`),
        },

        {
          path: "marketing",
          component: () => import(`@/${_root}/signUp/comp/agree/MarketingPage.vue`),
        },

        {
          path: "terms",
          component: () => import(`@/${_root}/signUp/comp/agree/TermsPage.vue`),
        },

        {
          path: "error/empty",
          component: () => import(`@/${_root}/error/ErrorPage.vue`),
        },
      ]
    },
    // {
    //   path: "/",
    //   // 사이드, 탑바 없이 풀 페이지
    //   component: () => import("@/layouts/home/LayoutFull.vue"),
    //   children: [
    //     {
    //       path: "/home",
    //       component: () => import(`@/${_root}/home/HomePage.vue`),
    //     },
    //   ]
    // },
    {
      path: "/",
      component: () => import(`@/${_root}/Index`),
      children: [
        {
          path: "/",
          component: () => import(`@/${_root}/Pages`),
          children: [
            {
              path: "/home",
              component: () => import(`@/${_root}/home/HomePage.vue`),
              meta: { auth: false }
            },
            {
              path: "/userInfo",
              component: () => import(`@/${_root}/userInfo/UserInfo.vue`),
              meta: { auth: true }
            },
            {
              path: "/changePassword",
              component: () => import(`@/${_root}/changePassword/ChangePassword.vue`),
              meta: { auth: true }
            },
            {
              path: "/test",
              component: () => import(`@/${_root}/test/Test.vue`),
              meta: { auth: true }
            },
          ]
        }
      ]
    },
  ]
});

router.beforeEach(async (to, from, next) => {
  if (to.meta.auth && !store.getters.isAuthorized) {
    console.log('인증이 필요합니다');
    next("/login");
    return;
  }
  next();
});

export default router;
